<div class="lp-collection-new-header">
  <app-city-switcher
    class="lp-collection-new-header__city"
    [mode]="'button'"
    [textfieldSize]="isDesktop ? 'm' : 's'"
    [(ngModel)]="city"
    (ngModelChange)="cityChange.emit($event)"
  ></app-city-switcher>

  <div *ngIf="isDesktop" class="lp-collection-new-header__buttons">
    <button
      tuiIconButton
      [appearance]="'lp-icon-block'"
      [size]="'l'"
      type="button"
      iconStart="@tui.heart"
      [tuiHint]="isDesktop ? ('components.loyaltyHeader.buttons.favoriteProducts' | translate) : ''"
      [routerLink]="'/loyalty/favorite-products'"
    ></button>

    <button
      tuiIconButton
      [appearance]="'lp-icon-block'"
      [size]="'l'"
      type="button"
      iconStart="@tui.percent"
      [tuiHint]="isDesktop ? ('components.loyaltyHeader.buttons.myProductCodes' | translate) : ''"
      [routerLink]="'/loyalty/my-product-codes'"
    ></button>

    <button
      *ngxPermissionsOnly="['loyaltyProgramOwnProductsViewing']"
      tuiIconButton
      [appearance]="'lp-icon-block'"
      [size]="'l'"
      type="button"
      iconStart="@tui.list"
      [tuiHint]="isDesktop ? ('components.loyaltyHeader.buttons.ownProducts' | translate) : ''"
      [routerLink]="'/loyalty/own-products'"
    ></button>

    <button
      *ngxPermissionsOnly="['loyaltyProgramCollectionsViewing']"
      tuiIconButton
      [appearance]="'lp-icon-block'"
      [size]="'l'"
      type="button"
      iconStart="@tui.layers"
      [tuiHint]="isDesktop ? ('components.loyaltyHeader.buttons.collections' | translate) : ''"
      [routerLink]="'/loyalty/collections'"
    ></button>
  </div>

  <div
    *ngIf="isMobile"
    class="header__menu-button"
    tuiDropdownAlign="left"
    [tuiDropdown]="dropdown"
    [tuiDropdownSided]="true"
    [(tuiDropdownOpen)]="dropdownOpen"
  >
    <button tuiIconButton type="button" iconStart="@tui.menu" [appearance]="'lp-icon'" [size]="'m'"></button>
  </div>
</div>

<ng-template #dropdown>
  <tui-data-list class="list" [size]="'m'">
    <button tuiOption new class="list-item" type="button" [routerLink]="'/loyalty/favorite-products'">
      <app-icon [src]="'@tui.heart'" size="14px"></app-icon>
      {{ 'components.loyaltyHeader.buttons.favoriteProducts' | translate }}
    </button>

    <button tuiOption new class="list-item" type="button" [routerLink]="'/loyalty/my-product-codes'">
      <app-icon [src]="'@tui.percent'" size="14px"></app-icon>
      {{ 'components.loyaltyHeader.buttons.myProductCodes' | translate }}
    </button>

    <button
      *ngxPermissionsOnly="['loyaltyProgramOwnProductsViewing']"
      tuiOption
      new
      class="list-item"
      type="button"
      [routerLink]="'/loyalty/own-products'"
    >
      <app-icon [src]="'@tui.list'" size="14px"></app-icon>
      {{ 'components.loyaltyHeader.buttons.ownProducts' | translate }}
    </button>

    <button
      *ngxPermissionsOnly="['loyaltyProgramCollectionsViewing']"
      tuiOption
      new
      class="list-item"
      type="button"
      [routerLink]="'/loyalty/collections'"
    >
      <app-icon [src]="'@tui.layers'" size="14px"></app-icon>
      {{ 'components.loyaltyHeader.buttons.collections' | translate }}
    </button>
  </tui-data-list>
</ng-template>
